import React, { useState, useMemo, useEffect } from 'react';
import { useSelector } from 'react-redux';

import moment from 'moment';

import { Report } from '~/components';
import {
  DateTime,
  Input,
  Autocomplete,
  MultiAutocomplete,
  RadioGroup,
  Select,
  Hidden,
} from '~/components/Form';
import { CRUDProfile, PesquisaTabela } from '~/components/Form/v2';
import { REL_ABASTECIMENTO } from '~/constants/default';
import {
  CENTRO_CUSTO_ABASTECIMENTO,
  GERENCIA_ABASTECIMENTO,
  CONTRATO_ABASTECIMENTO,
  MODULO_20_GRAUS,
  MODULO_FERROVIA,
} from '~/constants/modules';
import { t, can } from '~/helpers';

function Relabastecimento() {
  // ??console.log('ENTROU!!!!!');
  const [open, setOpen] = useState(true);
  const [produto, setProduto] = useState(0);
  const [inputValuePosto, setInputValuePosto] = React.useState('');

  const { abastsotaglidaclienteconfig } = useSelector(
    (state) => state.user.configs
  );

  const [bico, setBico] = useState(0);
  const [exibeGrupoAnalise, setGrupoAnalise] = useState(true);
  const [nomemodelo, setNomeModelo] = useState('');

  const [valuePosto, setValuePosto] = React.useState([]);

  const [valueBico, setValueBico] = React.useState(0);
  const [inputValueBico, setInputValueBico] = React.useState('');

  const [valueProduto, setValueProduto] = React.useState(0);
  const [inputValueProduto, setInputValueProduto] = React.useState('');

  const [tipoDeVeiculo, setTipoDeVeiculo] = React.useState(null);

  const start = moment()
    .subtract({ day: 7 })
    .set({ hour: 0, minute: 0, second: 0 });

  const end = moment().set({ hour: 23, minute: 59, second: 59 });

  const cellsCompany = useMemo(
    () => [
      {
        id: 'idempresaveiculo',
        label: t('s.cadastro.empresaveiculo.idempresaveiculo'),
        filter: { type: 'text' },
      },
      {
        id: 'nomeempresaveiculo',
        label: t('s.cadastro.empresaveiculo.nomeempresaveiculo'),
        filter: { type: 'text' },
      },
    ],
    []
  );

  const cellsVehicle = useMemo(
    () => [
      {
        id: 'idveiculo',
        label: t('s.configuracao.comboio.idveiculo'),
        filter: { type: 'text' },
      },
      {
        id: 'placaveiculo',
        label: t('s.cadastro.veiculo.placaveiculo'),
        filter: { type: 'text' },
      },
      {
        id: 'nomemodeloveiculo',
        label: t('s.menu.cadastro.veiculo.modelo'),
        filter: { type: 'text' },
      },
    ],
    []
  );

  const cellsModel = useMemo(
    () => [
      {
        id: 'idmodeloveiculo',
        label: t('s.cadastro.modeloveiculo.codigoauxiliarmodeloveiculo'),
        filter: { type: 'text' },
      },
      {
        id: 'nomemarcaveiculo',
        label: t('s.cadastro.modeloveiculo.nomemarcaveiculo'),
        filter: { type: 'text' },
      },
      {
        id: 'nomemodeloveiculo',
        label: t('s.cadastro.modeloveiculo.nomemodeloveiculo'),
        filter: { type: 'text' },
      },
    ],
    []
  );

  const cellsContract = useMemo(
    () => [
      {
        id: 'idcontrato',
        label: t('s.cadastro.contrato.idcontrato'),
        filter: { type: 'text' },
      },
      {
        id: 'nomecontrato',
        label: t('s.cadastro.contrato.nomecontrato'),
        filter: { type: 'text' },
      },
    ],
    []
  );

  const cellsUser = useMemo(
    () => [
      {
        id: 'codigousuario',
        label: t('s.cadastro.usuario.codigousuario'),
        filter: { type: 'text' },
      },
      {
        id: 'nomeusuario',
        label: t('s.cadastro.usuario.nomeusuario'),
        filter: { type: 'text' },
      },
    ],
    []
  );

  const tiposveiculos = [
    { value: 'L', label: t('s.menu.cadastro.veiculo.locomotiva') },
    { value: 'V', label: t('s.menu.cadastro.veiculo') }, // value 0 - 4
    { value: 'T', label: t('s.relatorio.geral.todos') },
  ];

  const orderoptions = [
    { value: 'LI', label: t('s.relatorio.abastecimento.opcaolistagem') },
    { value: 'PC', label: t('s.relatorio.abastecimento.opcaopostocomboio') },
    { value: 'BI', label: t('s.relatorio.abastecimento.opcaobico') },
    { value: 'PD', label: t('s.relatorio.abastecimento.opcaoproduto') },
    { value: 'EM', label: t('s.relatorio.abastecimento.opcaoempresa') },
    { value: 'FR', label: t('s.relatorio.abastecimento.opcaofrota') },
    { value: 'DT', label: t('s.relatorio.abastecimento.opcaodata') },
  ];
  if (can(CENTRO_CUSTO_ABASTECIMENTO)) {
    orderoptions.push({
      value: 'CC',
      label: t('s.relatorio.abastecimento.opcaocentrocusto'),
    });
  }
  if (can(GERENCIA_ABASTECIMENTO)) {
    orderoptions.push({
      value: 'GE',
      label: t('s.relatorio.abastecimento.opcaogerencia'),
    });
  }
  if (can(CONTRATO_ABASTECIMENTO)) {
    orderoptions.push({
      value: 'CT',
      label: t('s.relatorio.abastecimentolistagem.contrato'),
    });
  }

  function handleSerializeForm(params) {
    const { datahorainicial, datahorafinal, idproduto } = params;

    const idPosto =
      valuePosto === 0 ? '' : valuePosto.map((posto) => posto.idposto);
    const idBico = valueBico === 0 ? '' : valueBico;
    const idProduto = valueProduto === 0 ? '' : valueProduto;
    return {
      nomemodelo,
      ...params,
      idproduto: idProduto,
      idposto: idPosto,
      idbico: idBico,
    };
  }

  useEffect(() => {
    if (can(MODULO_FERROVIA)) {
      setTipoDeVeiculo('L');
    } else {
      setTipoDeVeiculo('T');
    }
  }, []);

  return (
    <Report
      open={open}
      onClose={() => setOpen(false)}
      title={t('s.relatorio.abastecimentolistagem')}
      relatorio="abastecimento"
      serialize={(param) => handleSerializeForm(param)}
      initials={{
        datahorainicial: start.format('DD/MM/YYYY HH:mm:ss'),
        datahorafinal: end.format('DD/MM/YYYY HH:mm:ss'),
        tipoveiculo: 'L',
        tipoordenacaoreport: 'LI',
        idperfilrelatorio: '0',
        idgrupocamposistema: REL_ABASTECIMENTO,
      }}
    >
      <DateTime
        label={t('s.geral.opcoes.datahorainicial')}
        name="datahorainicial"
        serialize={(value) =>
          value.set({ second: 0 }).format('DD/MM/YYYY HH:mm:ss')
        }
        time
      />
      <DateTime
        label={t('s.geral.opcoes.datahorafinal')}
        name="datahorafinal"
        serialize={(value) =>
          value.set({ second: 59 }).format('DD/MM/YYYY HH:mm:ss')
        }
        time
      />
      <MultiAutocomplete
        multiple
        name="idposto"
        label="codigonomeposto"
        url="postoscomboios"
        unique="idposto"
        title={t('s.geral.postocomboio')}
        hiddens={[{ name: 'codigonomeposto' }]}
        getValue={(value) => {
          setValuePosto(0);
          setInputValuePosto('');

          setValueBico(0);
          setInputValueBico('');

          setValueProduto(0);
          setInputValueProduto('');

          setBico(0);
          setProduto(0);
          setValueBico(0);
          setValuePosto(value);
        }}
      />

      <Autocomplete
        name="idbico"
        label="bicoprodutobico"
        url="bicos"
        unique="idbico"
        title={t('s.menu.configuracao.bico')}
        value={valueBico}
        inputValue={inputValueBico}
        onChange={(event, newValue) => {
          setValueBico(newValue);
        }}
        onInputChange={(event, newInputValueBico) => {
          setInputValueBico(newInputValueBico);
        }}
        disabled={valuePosto.length === 0 || valuePosto.length > 1}
        getValue={(value) => {
          setValueBico(value.idbico);
          setValueProduto(0);
          setInputValueProduto('');

          const formidproduto = document.getElementById('idproduto');
          formidproduto.innerText = '';

          if (value.idbico === null) {
            setBico(0);
            setProduto(0);
          } else {
            setProduto(value.idproduto);
            setBico(value.idbico);
          }
        }}
        params={{
          wherefield: ['idposto', 'tipoproduto'],
          valuewherefield: [valuePosto[0]?.idposto, 'C'],
          typewherefield: ['EQUALS', 'EQUALS'],
          orderfield: 'bicoprodutobico',
          ordination: 'asc',
        }}
      />

      <Autocomplete
        id="idproduto"
        name="idproduto"
        label="nomeabreviadoproduto"
        url="produtos"
        unique="idproduto"
        disabled={bico !== 0}
        value={valueProduto}
        inputValue={inputValueProduto}
        onChange={(event, newValue) => {
          setValueProduto(newValue);
        }}
        onInputChange={(event, newInputValueProduto) => {
          setInputValueProduto(newInputValueProduto);
        }}
        getValue={(value) => {
          if (value.idproduto !== null) {
            setValueProduto(value.idproduto);
          } else {
            setValueProduto(0);
          }

          setValueBico(0);
          setInputValueBico('');
        }}
        title={t('s.menu.configuracao.produto')}
        defaultValue=""
        hiddens={[{ name: 'nomeabreviadoproduto' }]}
        params={{
          wherefield: ['tipoproduto'],
          valuewherefield: ['C'],
          typewherefield: ['EQUALS'],
          orderfield: 'nomeabreviadoproduto',
          ordination: 'asc',
        }}
      />
      <PesquisaTabela
        name="idempresaveiculo"
        label={t('s.menu.cadastro.veiculo.empresa')}
        primary="idempresaveiculo"
        secondary="nomeempresaveiculo"
        url="empresasveiculos"
        header={cellsCompany}
      />
      {can(MODULO_FERROVIA) && (
        <Select
          name="tipoveiculo"
          variant="outlined"
          size="small"
          label={t('s.geral.camposistema.tipoveiculo')}
          options={tiposveiculos}
          getValue={(value) => {
            setTipoDeVeiculo(value);
          }}
        />
      )}
      {!can(MODULO_FERROVIA) && <Hidden name="tipoveiculo" value="" />}

      {/* <A2
        name="idmodeloveiculo"
        title={t('s.cadastro.veiculo.idmodeloveiculo')}
        label="nomemodelomarcamodeloveiculo"
        unique="idmodeloveiculo"
        url="modelosveiculos"
        getValue={(value) =>
          setNomeModelo(
            value.nomemodelomarcamodeloveiculo
              ? value.nomemodelomarcamodeloveiculo
              : ''
          )
        }
        params={{
          fieldlist: 'idmodeloveiculo,nomemodelomarcamodeloveiculo',
          orderfield: 'nomemodelomarcamodeloveiculo',
        }}
        query={{
          wherefield: 'tipomodeloveiculo',
          valuewherefield: 'L',
          typewherefield: tipoDeVeiculo === 'L' ? 'EQUALS' : 'NEQUALS',
        }}
      /> */}
      {tipoDeVeiculo === 'L' && (
        <PesquisaTabela
          name="idmodeloveiculo"
          label={t('s.cadastro.veiculo.idmodeloveiculo')}
          primary="idmodeloveiculo"
          secondary="nomemodelomarcamodeloveiculo"
          url="modelosveiculos"
          header={cellsModel}
          query={{
            wherefield: 'tipomodeloveiculo',
            valuewherefield: 'L',
            typewherefield: 'EQUALS',
          }}
          getValue={(value) =>
            setNomeModelo(
              value.nomemodelomarcamodeloveiculo
                ? value.nomemodelomarcamodeloveiculo
                : ''
            )
          }
        />
      )}
      {tipoDeVeiculo === 'V' && (
        <PesquisaTabela
          name="idmodeloveiculo"
          label={t('s.cadastro.veiculo.idmodeloveiculo')}
          primary="idmodeloveiculo"
          secondary="nomemodelomarcamodeloveiculo"
          url="modelosveiculos"
          header={cellsModel}
          query={{
            wherefield: 'tipomodeloveiculo',
            valuewherefield: 'V',
            typewherefield: 'EQUALS',
          }}
          getValue={(value) =>
            setNomeModelo(
              value.nomemodelomarcamodeloveiculo
                ? value.nomemodelomarcamodeloveiculo
                : ''
            )
          }
        />
      )}
      {tipoDeVeiculo === 'T' && (
        <PesquisaTabela
          name="idmodeloveiculo"
          label={t('s.cadastro.veiculo.idmodeloveiculo')}
          primary="idmodeloveiculo"
          secondary="nomemodelomarcamodeloveiculo"
          url="modelosveiculos"
          header={cellsModel}
          getValue={(value) =>
            setNomeModelo(
              value.nomemodelomarcamodeloveiculo
                ? value.nomemodelomarcamodeloveiculo
                : ''
            )
          }
        />
      )}

      {can(MODULO_FERROVIA) && tipoDeVeiculo !== 'T' && (
        <PesquisaTabela
          name="idveiculo"
          label={t('s.menu.cadastro.veiculo')}
          primary="idveiculo"
          secondary="nomemodeloveiculo"
          url="veiculos"
          header={cellsVehicle}
          query={{
            wherefield: 'tipoveiculo',
            valuewherefield: 5,
            typewherefield: tipoDeVeiculo === 'L' ? 'EQUALS' : 'NEQUALS',
          }}
        />
      )}

      {(!can(MODULO_FERROVIA) ||
        (can(MODULO_FERROVIA) && tipoDeVeiculo === 'T')) && (
        <PesquisaTabela
          name="idveiculo"
          label={t('s.menu.cadastro.veiculo')}
          primary="idveiculo"
          secondary="nomemodeloveiculo"
          url="veiculos"
          header={cellsVehicle}
        />
      )}
      {can(CONTRATO_ABASTECIMENTO) && (
        <PesquisaTabela
          name="idcontrato"
          label={t('s.menu.cadastro.veiculo.contrato')}
          primary="idcontrato"
          secondary="nomecontrato"
          url="contratos"
          header={cellsContract}
        />
      )}
      <PesquisaTabela
        name="frentista"
        label={t('s.relatorio.abastecimentocontingencia.frentista')}
        primary="codigousuario"
        secondary="nomeusuario"
        url="usuarios"
        header={cellsUser}
      />
      <Select
        name="tipoordenacaoreport"
        variant="outlined"
        size="small"
        label={t('s.relatorio.abastecimento.tipoordenacao')}
        options={orderoptions}
      />
      <CRUDProfile
        name="idperfilrelatorio"
        label={t('s.menu.cadastro.usuario.perfil')}
        report={REL_ABASTECIMENTO}
        onChange={(value) => {
          setGrupoAnalise(value == 0);
        }}
        nameReport={t('s.menu.operacao.abastecimento')}
      />
      {abastsotaglidaclienteconfig === '1' && (
        <Input
          name="tagveiculomovimentacaoabastecimento"
          label={t('s.cadastro.motorista.tagmotorista')}
          variant="outlined"
          fullWidth
          autoComplete="off"
          size="small"
          InputLabelProps={{
            shrink: true,
          }}
        />
      )}
      <Hidden name="idgrupocamposistema" />
      {exibeGrupoAnalise && (
        <RadioGroup
          name="analisereport"
          label={t('s.relatorio.geral.analise')}
          options={[
            {
              label: t('s.relatorio.geral.analiseanalitico'),
              value: 'Analitico',
            },
            {
              label: t('s.relatorio.geral.analisesintetico'),
              value: 'Sintetico',
            },
          ]}
          defaultValue="Analitico"
          serialize={(value) => value}
          row
        />
      )}
      {can(MODULO_20_GRAUS) && (
        <RadioGroup
          name="tiporelatorio"
          label={t('s.relatorio.geral.tiporelatorio')}
          options={[
            {
              label: t('s.relatorio.geral.ambiente'),
              value: 'ambiente',
            },
            {
              label: t('s.relatorio.geral.20graus'),
              value: '20graus',
            },
          ]}
          defaultValue="ambiente"
          serialize={(value) => value}
          row
        />
      )}
      <RadioGroup
        name="formato"
        label={t('s.relatorio.geral.formato')}
        options={[
          { label: 'PDF', value: 'pdf' },
          { label: 'Excel', value: 'excel' },
        ]}
        defaultValue="pdf"
        serialize={(value) => value}
        row
      />
    </Report>
  );
}

export default Relabastecimento;
